/**
 * Settings for Axios Http Api calls.
 * Create a copy of this file with name Request.js and enter config there.
 * Request.js file is not tracked in .git
 */

// Base url of backend app
// export const APP_BASE_URL = "http://wil.local/";

// // Base url of backend api
// export const API_BASE_URL = "http://wil.local/api/";

// // Base url of frontend app
// export const FRONT_BASE_URL = "http://localhost:3000/";

// export const BIDDING_URL = "";
// export const MAP_VIEW_URL = "";

export const APP_BASE_URL = "https://erp.triosoftinnovations.com";

// Base url of backend api
export const API_BASE_URL = "https://erp.triosoftinnovations.com/api/";

// Base url of frontend app
export const FRONT_BASE_URL = "https://erp.triosoftinnovations.com/";

export const BIDDING_URL = "";
export const MAP_VIEW_URL = "";
